// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.center{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 400px;
    background: white;
    border-radius: 10px;
    box-shadow: 10px 10px 15px rgba(0,0,0,0.05);
  }
  .center h1{
    text-align: center;
    padding: 20px 0;
    border-bottom: 1px solid silver;
  }
  .center form{
    padding: 0 40px;
    box-sizing: border-box;
  }
  form .txt_field{
    position: relative;
    border-bottom: 2px solid #adadad;
    margin: 30px 0;
  }
  .txt_field input{
    width: 100%;
    padding: 0 5px;
    height: 40px;
    font-size: 16px;
    border: none;
    background: none;
    outline: none;
  }
  .txt_field label{
    position: absolute;
    top: 50%;
    left: 5px;
    color: #adadad;
    transform: translateY(-50%);
    font-size: 16px;
    pointer-events: none;
    transition: .5s;
  }
  .txt_field span::before{
    content: '';
    position: absolute;
    top: 40px;
    left: 0;
    width: 0%;
    height: 2px;
    background: #2691d9;
    transition: .5s;
  }
  .txt_field input:focus ~ label,
  .txt_field input:valid ~ label{
    top: -5px;
    color: #2691d9;
  }
  .txt_field input:focus ~ span::before,
  .txt_field input:valid ~ span::before{
    width: 100%;
  }
  .pass{
    margin: -5px 0 20px 5px;
    color: #a6a6a6;
    cursor: pointer;
  }
  .pass:hover{
    text-decoration: underline;
  }
  input[type="submit"]{
    width: 100%;
    height: 50px;
    border: 1px solid;
    background: #2691d9;
    border-radius: 25px;
    font-size: 18px;
    color: #e9f4fb;
    font-weight: 700;
    cursor: pointer;
    outline: none;
  }
  input[type="submit"]:hover{
    border-color: #2691d9;
    transition: .5s;
  }
  .signup_link{
    margin: 30px 0;
    text-align: center;
    font-size: 16px;
    color: #666666;
  }
  .signup_link a{
    color: #2691d9;
    text-decoration: none;
  }
  .signup_link a:hover{
    text-decoration: underline;
  }`, "",{"version":3,"sources":["webpack://./src/Pages/Recovery/Recovery.css"],"names":[],"mappings":";AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,2CAA2C;EAC7C;EACA;IACE,kBAAkB;IAClB,eAAe;IACf,+BAA+B;EACjC;EACA;IACE,eAAe;IACf,sBAAsB;EACxB;EACA;IACE,kBAAkB;IAClB,gCAAgC;IAChC,cAAc;EAChB;EACA;IACE,WAAW;IACX,cAAc;IACd,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,cAAc;IACd,2BAA2B;IAC3B,eAAe;IACf,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,SAAS;IACT,WAAW;IACX,mBAAmB;IACnB,eAAe;EACjB;EACA;;IAEE,SAAS;IACT,cAAc;EAChB;EACA;;IAEE,WAAW;EACb;EACA;IACE,uBAAuB;IACvB,cAAc;IACd,eAAe;EACjB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,aAAa;EACf;EACA;IACE,qBAAqB;IACrB,eAAe;EACjB;EACA;IACE,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,cAAc;EAChB;EACA;IACE,cAAc;IACd,qBAAqB;EACvB;EACA;IACE,0BAA0B;EAC5B","sourcesContent":["\n.center{\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 400px;\n    background: white;\n    border-radius: 10px;\n    box-shadow: 10px 10px 15px rgba(0,0,0,0.05);\n  }\n  .center h1{\n    text-align: center;\n    padding: 20px 0;\n    border-bottom: 1px solid silver;\n  }\n  .center form{\n    padding: 0 40px;\n    box-sizing: border-box;\n  }\n  form .txt_field{\n    position: relative;\n    border-bottom: 2px solid #adadad;\n    margin: 30px 0;\n  }\n  .txt_field input{\n    width: 100%;\n    padding: 0 5px;\n    height: 40px;\n    font-size: 16px;\n    border: none;\n    background: none;\n    outline: none;\n  }\n  .txt_field label{\n    position: absolute;\n    top: 50%;\n    left: 5px;\n    color: #adadad;\n    transform: translateY(-50%);\n    font-size: 16px;\n    pointer-events: none;\n    transition: .5s;\n  }\n  .txt_field span::before{\n    content: '';\n    position: absolute;\n    top: 40px;\n    left: 0;\n    width: 0%;\n    height: 2px;\n    background: #2691d9;\n    transition: .5s;\n  }\n  .txt_field input:focus ~ label,\n  .txt_field input:valid ~ label{\n    top: -5px;\n    color: #2691d9;\n  }\n  .txt_field input:focus ~ span::before,\n  .txt_field input:valid ~ span::before{\n    width: 100%;\n  }\n  .pass{\n    margin: -5px 0 20px 5px;\n    color: #a6a6a6;\n    cursor: pointer;\n  }\n  .pass:hover{\n    text-decoration: underline;\n  }\n  input[type=\"submit\"]{\n    width: 100%;\n    height: 50px;\n    border: 1px solid;\n    background: #2691d9;\n    border-radius: 25px;\n    font-size: 18px;\n    color: #e9f4fb;\n    font-weight: 700;\n    cursor: pointer;\n    outline: none;\n  }\n  input[type=\"submit\"]:hover{\n    border-color: #2691d9;\n    transition: .5s;\n  }\n  .signup_link{\n    margin: 30px 0;\n    text-align: center;\n    font-size: 16px;\n    color: #666666;\n  }\n  .signup_link a{\n    color: #2691d9;\n    text-decoration: none;\n  }\n  .signup_link a:hover{\n    text-decoration: underline;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
